import { render, staticRenderFns } from "./alert-recipients.vue?vue&type=template&id=05c848ff&"
import script from "./alert-recipients.vue?vue&type=script&lang=js&"
export * from "./alert-recipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports